import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CellTemplate } from '@nousmedis/cc-types';
import { CcGridTemplate } from 'app/modules/catalog-cloud/models/cc-grid-template.model';
import { CcGrid } from 'app/modules/catalog-cloud/models/cc-grid.model';
import { UserService } from 'app/modules/user/services/user.service';

@Component({
  selector: 'app-page-template-example',
  templateUrl: './page-template-example.component.html',
  styleUrls: ['./page-template-example.component.scss']
})
export class PageTemplateExampleComponent implements AfterViewInit, OnChanges, OnInit {

  rndLayout: string = "";
  @Input() cols: number = 1; // Número de columnas
  @Input() rows: number = 1; // Número de filas
  @Input() imageSrc: string = ''; // BLOB de la imagen
  @Input() cells: CellTemplate[] = []; // Celdas de la plantilla
  @Input() locked: boolean = true; // Bloquear la plantilla
  @Output() modifiedCells: EventEmitter<CellTemplate[]> = new EventEmitter<CellTemplate[]>();
  width: number = 0; // Ancho del contenedor
  height: number = 0; // Alto del contenedor
  colwidth: number = 1; // Ancho de las columnas
  rowheight: number = 1; // Alto de las filas
  templateLayout: HTMLElement;

  debug: boolean = false;
  grid: CcGridTemplate;
  userId: string = '';

  private resizeObserver: ResizeObserver;

  constructor (private cdr: ChangeDetectorRef, private userServ: UserService) {
    this.rndLayout = this.generateRandomNumber();
    this.userId = this.userServ.getCurrentUser().id;
    //this.grid.setGrid(this.cells);

  }

  ngOnInit(): void {
    this.grid = new CcGridTemplate(this.rows, this.cols);
    this.grid.setColumns(this.cols);
    this.grid.setRows(this.rows);
    this.grid.setGrid(this.cells);
    this.grid.recalcCells();
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Solo recalcular cuando cambien cols o rows
    let changeGrid = false;

    if (changes['cols'] || changes['rows']) {

      if (changes['cols'] && !changes['cols'].firstChange) {
        this.cols = changes['cols'].currentValue;
        this.grid.setColumns(this.cols);
        changeGrid = true;
      }
      if (changes['rows'] && !changes['rows'].firstChange) {
        this.rows = changes['rows'].currentValue;
        this.grid.setRows(this.rows);
        changeGrid = true;
      }
      
      if (changeGrid) {
        this.setNewGrid();

        this.grid.setGrid(this.cells);
        this.grid.recalcCells();

      }



    }
  }

  setNewGrid() {
    let cellNumber = 0;
    //TODO: Cambiar Esto para asegurarse que ni se actualizan sin previo aviso ni nada por el estilo
    this.cells = [];
    for (let row = 1; row <= this.rows; row++) {
      for (let col = 1; col <= this.cols; col++) {
        this.cells.push({
          id: undefined,
          rowPosition: row,
          columnPosition: col,
          rowWidth: 1,
          columnWith: 1,
          cellNumber: cellNumber,
          visible: true,
          createdBy: this.userId
        });
        cellNumber++;
      }
    }
  }
  ngAfterViewInit(): void {


    //this.grid.setGrid(this.cells);
  }

  // Método para generar un número aleatorio para el id del layout
  generateRandomNumber(): string {
    return Math.floor(Math.random() * 100).toString();
  }

  changeCell(event: any) {
    this.modifiedCells.emit(event);

  }

}
